import { divideAccuracy, goJoinEvent } from "@/lobby_common/utils/utils";
import { thirdLogin, getLoginIcon } from "@/lobby_common/utils/authLogin.js";
import { getActivityAmount, aggRegisterReward } from "@/lobby_common/api/activity_gen.js";
import { formatLang } from "@/lobby_common/utils/utils";
export default {
  name: "mode1",
  components: {},
  data() {
    return {
      divideAccuracy,
      vipData: {},
      percentage: 0,
      coinCode: '',
      tips: "",
      chargeTips: "",
      rechargeTips: "",
      currentIndex: 0,
      intervalId: null,
    };
  },
  props: {
    item: {
      type: [Object],
      default: () => ({}),
    },
    skeletonLoading: {
      type: Boolean,
      default: true,
    },
    curindex: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    images() {
      let imgStr = this.$utils.lang_data(this.lang, this.item.list[this.showStatus], 'langInfoObj')?.img
      let imgs = imgStr.split(',')
      return imgs
    },
    currentImage() {
      return this.$utils.returnImgUrl(this.images[this.currentIndex])
    },
    getImgHeight() {
      const containerWidth =
        document.body.clientWidth > 1340
          ? 1280
          : document.body.clientWidth - 60;
      const num = 480 / 1340;
      return containerWidth * num;
    },
    lang() {
      return this.$store.getters.getLang;
    },
    showStatus() {
      if (this.isLogin && this.isRecharge) {
        return 2;
      }
      if (this.isLogin && !this.isRecharge) {
        return 1;
      }
      // 未登陆
      return 0;
    },
    hasImg() {
      return Boolean(
        this.item.list[this.showStatus].langInfoObj[this.lang]?.img
      );
    },
    isLogin() {
      return this.$store.getters.login;
    },
    isMobile() {
      return this.$store.getters.getIsMobile;
    },
    isRecharge() {
      return this.$store.getters.user?.isRecharge;
    },
    userData() {
      return this.$store.getters.user;
    },
    coinSymbol() {
      return this.$store.getters.user?.coin_symbol;
    },
    getLoginConfig() {
      return this.$store.getters.getPacketConfig?.loginConfig || {};
    },
    titleAlignment() {
      return this.$store.getters.getPacketConfig?.packetInfo?.config?.titleAlignment
    },
    coinObj() {
      const arr = this.$store.getters.getPacketConfig?.coinList || [];
      const obj = {};
      arr.map((v) => {
        obj[v.coinCode] = v;
      });
      return obj || {};
    },
    curCoinObj() {
      return this.coinObj[this.coinCode] || {}
    },
  },
  mounted() {
    this.getData();
    this.startCarousel()
  },
  beforeUnmount() {
    this.stopCarousel();
  },
  methods: {
    startCarousel() {
      this.intervalId = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.images.length
      }, 3000) // 每3秒切换一次
    },
    stopCarousel() {
      if (this.intervalId) {
        clearInterval(this.intervalId)
      }
    },
    formatLang,
    changeTab(val) {
      this.$Bus.$emit("showLogin", { childTab: val.type });
    },
    handleClick(index) {
      if (this.item?.list[index]?.jump) {
        goJoinEvent(this.item.list[index].jump);
      }
    },
    toLogin() {
      this.$eventPost("click", {
        eid: `101_12_${this.curindex}_0`,
        time: Date.now(),
      });
      this.$Bus.$emit("showLogin");
    },
    // 充值弹窗
    toCharge() {
      this.$Bus.$emit("showCharge", { show: true });
      this.$Bus.$emit("showExchange", { show: false });
    },
    async getData() {
      const { data, code } = await aggRegisterReward();
      if (code === 0) {
        this.vipData = data;

        let { amount, coinCode, rewardRatio } = data;
        rewardRatio = Number(rewardRatio) ? Number(rewardRatio) / 100 : 0;
        this.coinCode = coinCode;
        let tips = "", chargeTips = "";
        if (Number(amount) && Number(rewardRatio)) {
          chargeTips = `${this.divideAccuracy(amount, this.curCoinObj.accuracy)}+${Number(rewardRatio)}%`;
        } else if (Number(amount)) {
          chargeTips = `${this.divideAccuracy(amount, this.curCoinObj.accuracy)}`;
        } else if (Number(rewardRatio)) {
          chargeTips = `${Number(rewardRatio)}%`;
        }
        if (Number(amount)) {
          tips = `${this.divideAccuracy(amount, this.curCoinObj.accuracy)}`;
        }
        this.tips = tips;
        this.chargeTips = chargeTips;
        if (rewardRatio) {
          this.rechargeTips = `${Number(rewardRatio)}%`;
        }
      }
    },
  },
};
